import Toast from 'react-hot-toast'
import {HiyaVerHost} from 'hiya-common/src/constant'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {oldRepositoryOrigin} from 'hiya-common/src/utils'
import {Toast as aToast} from 'antd-mobile'
import {cloneDeep} from 'lodash'
import {createRechargeOrderV2} from './service'
import {IProductsResp} from './reducers'
import pic_google from './images/wallet-googlepay.png'
import pic_apple from './images/wallet-applepay.png'
import pic_huawei from './images/m-wallet-huaweipay.png'
import {EXP_TYPE_ENUM} from './const'

export const closeCurWindow = () => {
  window.HiyaJSBridge.callHandler('closeWindow')
}

export const format = () => {}

/**
 daliy_recharge: higo_year_recharge_activity_daliy 年度活动每日充值页面充值

 time_recharge_bouns: higo_year_recharge_activity_time 年度活动限时充值页面充值

 exclusive_recharge_bouns: higo_year_recharge_activity_exclusive 年度活动专属福利充值页面充值
 */
const POINT_MAP = {
  daliy_recharge: 'higo_year_recharge_activity_daliy',
  time_recharge_bouns: 'higo_year_recharge_activity_time',
  exclusive_recharge_bouns: 'higo_year_recharge_activity_exclusive',

  'Weekly recharge': 'weekly_recharge_activity_daily',
  'Surprise recharge': 'surprise_recharge_activity_time',
  'Limited time recharge': 'limited_time_recharge_activity',
}
export const getRechargePointType = (type: string) => {
  return POINT_MAP[type] || type || ''
}

/** 官方支付 */
export const handlePurchase = (productId, from, extraParams, callback) => {
  const {env} = window.store.getState()
  const {otherInfo} = env
  window.HiyaJSBridge.callHandler(
    'purchase',
    {
      productId,
      from: getRechargePointType(otherInfo.from) || from || 'purchaseFrom',
      ...extraParams,
    },
    callback
  )
}
export const handleHuaweiPurchase = (
  productId,
  from,
  extraParams,
  callback
) => {
  const {env} = window.store.getState()
  const {otherInfo} = env
  window.HiyaJSBridge.callHandler(
    'huaweiPurchase',
    {
      productId,
      from: getRechargePointType(otherInfo.from) || from || 'purchaseFrom',
      ...extraParams,
    },
    callback
  )
}

const toRedirectForm = ({
  redirect_method = 'post',
  redirect_param = {},
  redirect_url = '',
}) => {
  window.HiyaJSBridge.callHandler('openScheme', {
    url: `hiya://openWindow?fullscreen=0&external=0&need_user_info=0&other_info=${encodeURIComponent(
      JSON.stringify({
        params: redirect_param,
        action: redirect_url,
        method: redirect_method,
      })
    )}&url=${oldRepositoryOrigin()}/#/recharge/form`,
  })
}
/** 普通下单 */
export const creditCardPurchase = (
  item,
  countryObj,
  t,
  from: 'wallet' | 'quick_pop' | 'return_user_gift_package',
  // recharge_type,
  otherParams: any = {}
) => {
  const {env, WalletAdvanced} = window.store.getState()
  const {otherInfo, deviceinfo} = env
  const {price, currency} = item
  const tId = Toast.loading('Loading', {duration: 8000})
  // const recharge_type = 0
  // 0 用户   1 币商
  let recharge_type = 0
  try {
    if (WalletAdvanced.account.recharge_agency_info.is_recharge_agency) {
      recharge_type = 1
    }
  } catch (error) {
    console.log('error :>> ', error)
  }
  const bonus = item.activity_bonus || {}
  const {activity_type, sub_activity_type} = bonus
  let extraParams = {}
  // if (activity_type && sub_activity_type) {
  if (activity_type) {
    extraParams = {
      activity_type,
      sub_activity_type,
    }
  }

  return createRechargeOrderV2({
    product_id: item.product_id,
    code: countryObj.code,
    pay_method_id: item.pay_method_id,
    from: getRechargePointType(otherInfo.from) || from,
    source: 'wallet',
    recharge_type,
    ...otherParams,
    ...extraParams,
  })
    .then((res) => {
      if (res.ret === 1) {
        if (res.data.err_code === 2) {
          Toast.remove()
          Toast.custom(t('over20'), {duration: 2000})
          return
        }
        if (res.data.jump_pay_info) {
          window.HiyaJSBridge.callHandler('openScheme', {
            url: `hiya://openWindow?fullscreen=0&external=0&need_user_info=1&other_info=${encodeURIComponent(
              JSON.stringify({...item, code: countryObj.code})
            )}&url=${HiyaVerHost}/userinfocollection`,
          })
        } else if (res.data.request_url) {
          const otherInfoObj = {} as {isKlarna?: number}
          if (item.name.toLocaleLowerCase() === 'klarna') {
            otherInfoObj.isKlarna = 1
          }
          const otherInfoInner = encodeURIComponent(
            JSON.stringify(otherInfoObj)
          )
          const requestUrl = res.data.request_url
          const isHttpUrl = /^https?:\/\//i.test(requestUrl)
          if (isHttpUrl) {
            window.HiyaJSBridge.callHandler('openScheme', {
              url: `hiya://openWindow?fullscreen=${
                res.data.fullscreen
              }&other_info=${otherInfoInner}&external=${
                res.data.jump_out ? 1 : 0
              }&need_user_info=${
                res.data.need_user_info
              }&url=${encodeURIComponent(requestUrl)}`,
            })
          } else {
            // 兼容自定义协议的跳转
            window.open(requestUrl)
          }
        } else if (
          res.data.redirect_info &&
          res.data.redirect_info.redirect_url
        ) {
          toRedirectForm(res.data.redirect_info)
        } else {
          aToast.show(t('订单失败'))
          Toast.remove()
        }
        setTimeout(() => {
          Toast.remove()
        }, 500)

        // eslint-disable-next-line consistent-return
        return res
      }
      Toast.remove()
      onlyToast(res.msg)
    })
    .catch(() => {
      // 防止将错误的err一起清除
      Toast.remove(tId)
    })
}

/** applepay下单 */
export const applepayPurchase = (
  item,
  countryObj,
  t,
  from: 'wallet' | 'quick_pop' | 'return_user_gift_package',
  // recharge_type,
  otherParams: any = {}
) => {
  const {env, WalletAdvanced} = window.store.getState()
  const {otherInfo} = env
  const tId = Toast.loading('Loading', {duration: 8000})
  // const recharge_type = 0
  // 0 用户   1 币商
  let recharge_type = 0
  try {
    if (WalletAdvanced.account.recharge_agency_info.is_recharge_agency) {
      recharge_type = 1
    }
  } catch (error) {
    console.log('error :>> ', error)
  }
  const bonus = item.activity_bonus || {}
  const {activity_type, sub_activity_type} = bonus
  let extraParams = {}
  // if (activity_type && sub_activity_type) {
  if (activity_type) {
    extraParams = {
      activity_type,
      sub_activity_type,
    }
  }

  return new Promise((resolve, reject) => {
    createRechargeOrderV2({
      product_id: item.product_id,
      code: countryObj.code,
      pay_method_id: item.pay_method_id,
      from: getRechargePointType(otherInfo.from) || from,
      source: 'wallet',
      recharge_type,
      ...otherParams,
      ...extraParams,
    })
      .then((res) => {
        console.log('applepayPurchase000', res)
        if (res.ret === 1) {
          if (res.data.err_code === 2) {
            Toast.remove()
            Toast.custom(t('over20'), {duration: 2000})
            reject(new Error(t('over20')))
            return
          }
          resolve(res.data)
          return
        }
        Toast.remove()
        onlyToast(res.msg)
      })
      .catch(() => {
        // 防止将错误的err一起清除
        Toast.remove(tId)
        reject(tId)
      })
  })
}

// 判断字符串是否包含 apple pay | google pay
// export const isAppleOrGooglePay = (name: string) => {
//   const reg = new RegExp(//)
// }

const THIRD_PARTY_NAME = ['airwallex', 'payermax']
const OFFICE_DEFAULT_SCORE = 200

/**
 * 是否需要弹窗
 * @param name 子渠道名称
 * @param channelName 渠道名称
 * @returns 是否需要弹窗
 */
export const needShowModal = (name: string, channelName: string) => {
  const lowerCaseName = name.toLocaleLowerCase()

  return (
    ['airwallex', 'antom'].includes(channelName) &&
    // lowerCaseName.includes('applepay') ||
    // lowerCaseName.includes('apple pay') ||
    (lowerCaseName.includes('googlepay') ||
      lowerCaseName.includes('google pay'))
  )
}

const formatList = (
  list: any[],
  map,
  mergeType: 'coin' | 'price',
  office?: {
    img: string
    name: string
    tag: string
    score: number
  }
) => {
  const result = {...map}
  list.reduce((pre, cur) => {
    const {coins_display, price} = cur
    const key = mergeType === 'coin' ? coins_display : price
    const item = result[key]

    let formatName = cur.name || office.name
    //  airwallex 支付 applePay 或者 GooglePay 名称调整
    const lowerCaseName = formatName.toLocaleLowerCase()
    // // OXXO 同名渠道追加 channel_name 以作区分
    // if (lowerCaseName.includes('oxxo')) {
    //   formatName = `${cur.name || office.name}(${cur.channel_name})`
    // }

    if (THIRD_PARTY_NAME.includes(cur.channel_name)) {
      if (
        lowerCaseName.includes('googlepay') ||
        lowerCaseName.includes('google pay')
      ) {
        formatName = `${cur.name || office.name}(web page)`
      }
    }
    if (item && key !== undefined) {
      item.channel.push({
        ...cur,
        name: cur.name || office.name,
        last_succeed: !!cur.last_succeed,
        img: cur.img || office.img,
        tag: office?.tag || '',
        score: cur.score || office?.score || 0,
        formatName,
      })
      if (cur.last_succeed) {
        item.last_succeed = cur.last_succeed
      }
    } else {
      result[key] = {
        payment_id: cur.payment_id,
        channel_name: cur.channel_name,
        coins: cur.coins,
        coins_display: cur.coins_display,
        currency: cur.currency,
        discount_amount: cur.discount_amount,
        price: cur.price,
        product_id: cur.product_id,
        activity_bonus: cur.activity_bonus || {},
        last_succeed: !!cur.last_succeed,
        channel: [
          {
            ...cur,
            name: cur.name || office.name,
            last_succeed: !!cur.last_succeed,
            img: cur.img || office.img,
            tag: office?.tag || '',
            score: cur.score || office?.score || 0,
            formatName,
          },
        ],
      }
    }
    return pre
  }, result)
  return result
}

// 聚合
const mergeCoinsOrPrice = (
  data: IProductsResp,
  type: 'coin' | 'price',
  h_dt?: number
) => {
  const {list, huawei_list, third_party_list, third_party_list_v3} = data
  const map: any = {}

  const office = {
    img: pic_apple,
    name: 'Apple Pay',
    tag: '',
    score: OFFICE_DEFAULT_SCORE,
  }
  if (typeof window !== 'undefined') {
    // client
    let dt = h_dt
    if (dt === undefined) {
      const searchStr = window.location.search
      const matchResult =
        decodeURIComponent(searchStr).match(/"h_dt"\s*:\s*(\d+)/)
      if (matchResult && matchResult.length > 1) {
        dt = parseInt(matchResult[1], 10)
      }
    }
    office.img = dt === 0 ? pic_google : pic_apple
    office.name = dt === 0 ? 'Google Pay' : 'Apple Pay'
    office.tag = dt === 0 ? 'google' : 'apple'
  }
  if (h_dt !== undefined) {
    office.img = h_dt === 0 ? pic_google : pic_apple
    office.name = h_dt === 0 ? 'Google Pay' : 'Apple Pay'
    office.tag = h_dt === 0 ? 'google' : 'apple'
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  Object.assign(map, list && formatList(list, map, type, office))
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  Object.assign(
    map,
    huawei_list &&
      formatList(huawei_list, map, type, {
        img: pic_huawei,
        name: 'Huawei Pay',
        tag: 'huawei',
        score: OFFICE_DEFAULT_SCORE,
      })
  )

  const thirdPartyList =
    type === 'coin' ? third_party_list : third_party_list_v3

  const sortKey = type === 'coin' ? 'price' : 'coins'
  if (thirdPartyList) {
    thirdPartyList.forEach((item) => {
      // 保证最低价格或则最低金币为第一项
      const thirdPayList = cloneDeep(item.third_pay_list).sort(
        (a, b) => a[sortKey] - b[sortKey]
      )
      Object.assign(
        map,
        formatList(
          thirdPayList.map((subItem) => {
            const extra =
              type === 'coin'
                ? {
                    coins: item.coins || 0,
                    coins_display: item.coins_display || 0,
                  }
                : {
                    price: item.price || 0,
                    currency: item.currency || '',
                  }
            return {
              ...subItem,
              // coins: item.coins,
              // price: item.price,
              // currency: item.currency,
              ...extra,
              activity_bonus: item.activity_bonus,
            }
          }),
          map,
          type
        )
      )
    })
  }

  return map
}
export const formatProduct = (data: IProductsResp, h_dt?: number) => {
  const {order_exp, pay_page_exp_type} = data
  let coinsMap = {}
  if (pay_page_exp_type === EXP_TYPE_ENUM.BASE) {
    coinsMap = mergeCoinsOrPrice(data, 'coin', h_dt)
  } else {
    coinsMap = mergeCoinsOrPrice(data, 'price', h_dt)
  }

  // coinsMap 下 channel 根据 score 降序排序
  Object.keys(coinsMap).forEach((key) => {
    const originChannel = coinsMap[key].channel
    // 实验组
    if (order_exp) {
      /**
       * 进入实验组的用户，官方渠道（applepay&googlepay=排序分200、币商排序分=100
       * 三方渠道根据后台配置（同一个后台）
       * 再由所有排序分由大到小->上至下排序
       * 进入实验组的用户去掉历史充值成功状态，默认选中排序最大的支付渠道
       */
      // originChannel.forEach((c) => {
      //   // 重置状态
      //   // eslint-disable-next-line no-param-reassign
      //   c.last_succeed = false
      // })
      originChannel.sort((a, b) => b.score - a.score)
      // // 默认选中排序最大的支付渠道
      // if (originChannel[0]) {
      //   originChannel[0].last_succeed = true
      // }
    } else {
      /**
       * 进入对照组的用户，官方充值在第一个位置、币商在最下面。
       * 三方渠道按照排序分进行排序
       */
      // const needSortChannel = originChannel.filter((c) => !c.tag)
      originChannel.forEach((c) => {
        if (c.tag) {
          // eslint-disable-next-line no-param-reassign
          c.score = Infinity
        }
      })
      originChannel.sort((a, b) => b.score - a.score)
    }
    // item.channel?.sort((a, b) => b.score - a.score)
  })

  return Object.values(coinsMap)
  // return coinsMap
  // return result
}
